export const RECEIPT_TYPES: { ORDER: "order"; CHARGE: "charge" } = {
    ORDER: 'order' as 'order',
    CHARGE: 'charge' as 'charge',
};